"use client";

import { useState } from "react";
import { TechnicalAnalysis } from "react-ts-tradingview-widgets";
import "./index.css";

export const symbols = [
  "CNERGY",
  "FFL",
  "BOP",
  "CPHL",
  "PREMA",
  "PSO",
  "SSGC",
  "PRL",
  "TPLP",
  "PSX",
  "TRG",
  "PPL",
  "EFERT",
  "KEL",
  "PIBTL",
  "WTL",
  "TBL",
  "HASCOL",
  "MLCF",
  "KOSM",
  "PAEL",
  "SNGP",
  "DCL",
  "EPQL",
  "ENGROH",
  "UBL",
  "SLGL",
  "PTC",
  "TELE",
  "TREET",
  "PACE",
  "NBP",
  "DGKC",
  "OGDC",
  "FCCL",
  "HUBC",
  "MARI",
  "FCL",
  "BGL",
  "SEARL",
  "BNL",
  "CSAP",
  "AICL",
  "DSIL",
  "OCTOPUS",
  "OBOYR2",
  "CWSM",
  "AIRLINK",
  "AVN",
  "LOADS",
  "LPL",
  "POWER",
  "BFAGRO",
  "SPEL",
  "FABL",
  "PIAHCLA",
  "SYM",
  "DFML",
  "TOMCL",
  "GAMON",
];

const Technical = () => {
  const [selectedSymbol, setSelectedSymbol] = useState("SYM");

  const handleSymbolChange = (event) => {
    setSelectedSymbol(event.target.value);
  };

  return (
    <div className="main-container">
      <div className="control-bar">
        <div className="title-area">
          <h1>Technical Analysis</h1>
        </div>
        <div className="symbol-control">
          <p htmlFor="symbol-select">Symbol:</p>
          <select
            id="symbol-select"
            value={selectedSymbol}
            onChange={handleSymbolChange}
          >
            {symbols.map((symbol) => (
              <option key={symbol} value={symbol}>
                {symbol}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="chart-area">
        <TechnicalAnalysis
          symbol={`PSX:${selectedSymbol}`}
          colorTheme="light"
          width="100%"
          height={600}
          displayMode="multiple"
          showIntervalTabs={true}
        />
      </div>
    </div>
  );
};

export default Technical;
